function stripCredentials(url) {
  url.searchParams.delete('t')
  url.searchParams.delete('token')
  if (url.searchParams.get('type') === 'app') url.searchParams.delete('type')
}

export function getMeetingLoginUrl(href) {
  const url = new URL(href)
  stripCredentials(url)
  const previousRedirect = url.searchParams.get('redirect')
  url.searchParams.delete('redirect')
  const meeting = url.pathname.match(/^\/(?:host|moderator|appPage)\/([^/]+)\/?$/)
  if (meeting) {
    const redirect = url.pathname + url.search + url.hash
    url.pathname = `/welcomePage/${meeting[1]}`
    url.searchParams.set('redirect', redirect)
  } else if (url.pathname.startsWith('/welcomePage/')) {
    if (previousRedirect?.startsWith('/') && !previousRedirect.startsWith('//')) {
      const target = new URL(previousRedirect, url.origin)
      if (target.origin === url.origin && /^\/(?:host|moderator|appPage)\//.test(target.pathname)) {
        stripCredentials(target)
        target.searchParams.delete('redirect')
        url.searchParams.set('redirect', target.pathname + target.search + target.hash)
      }
    }
  } else {
    const fallback = new URL('/login', url.origin)
    if (url.searchParams.has('lang')) fallback.searchParams.set('lang', url.searchParams.get('lang'))
    return fallback.href
  }
  return url.href
}

export function createMeetingLoginRedirect(win) {
  let started = false
  return () => {
    if (started) return
    started = true
    win.name = ''
    // Replace the current document to release the old RTC connection, without
    // closing the room for other participants or requesting confirmation.
    win.location.replace(getMeetingLoginUrl(win.location.href))
  }
}

let redirect
export function redirectToMeetingLogin() {
  redirect ||= createMeetingLoginRedirect(window)
  redirect()
}
